import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ClientLogger } from 'bernie-client';
import { Map } from '@shared-ui/lodging-property-details';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { InfositePageName } from 'constants/pages';
import { EssClientLogger } from 'typeahead-client-logger';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
const getProductLine = uisPageName => uisPageName === InfositePageName.SA.valueOf() ? 'Lodging' : 'Package';
const PropertyMap = inject('page', 'map', 'analytics')(observer(({
  inputs,
  onClose,
  page,
  map,
  analytics
}) => {
  var _a;
  const {
    reset
  } = useClickstreamAnalytics();
  const triggerRef = React.useRef(null);
  const pageName = (page === null || page === void 0 ? void 0 : page.pageName) || InfositePageName.SA;
  const productLine = getProductLine(pageName);
  reset({
    data: {
      experience: {
        // eslint-disable-next-line camelcase
        page_product_line: productLine
      }
    },
    config: {
      isEgClickstream: true
    }
  });
  const setSavedFeature = map ? customPlace => map.setCustomPlace(customPlace) : undefined;
  const savedFeature = (_a = map === null || map === void 0 ? void 0 : map.customPlaces) === null || _a === void 0 ? void 0 : _a[0];
  const essLogger = new EssClientLogger(analytics, ClientLogger, '');
  const mapProps = {
    inputs,
    onClose,
    setSavedFeature,
    savedFeature,
    essLogger,
    triggerRef
  };
  return React.createElement("div", {
    className: "shared-ui-map uitk-dialog-layer-responsive",
    "data-stid": "infosite-map"
  }, React.createElement(Map, Object.assign({}, mapProps)));
}));
export const SharedUiMap = withSharedUiPropertyDetails(PropertyMap);
SharedUiMap.displayName = 'SharedUiMap';